import { flow } from "fp-ts/es6/function"
import T from "prop-types"
import { F } from "ramda"
import React, { useEffect, useState } from "react"

import { Button } from "../../molecules/index.js"

import {
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogContentText,
  StyledDialogTitle,
  StyledPaper,
  StyledPopper,
} from "./components.jsx"

export const Popper = ({
  anchorRef,
  cancelLabel = "Cancel",
  confirmDisabled,
  confirmLabel = "Ok",
  dialogTitle = "Please confirm",
  contentText,
  actionsButtons,
  id,
  isDialogVisible,
  placement = "top-start",
  onCancel: cancelCallback = () => undefined,
  onConfirm: confirmCallback = () => undefined,
}) => {
  const [isVisible, dialogTumbler] = useState(isDialogVisible)
  const onConfirm = flow(confirmCallback, F, dialogTumbler)
  const onCancel = flow(cancelCallback, F, dialogTumbler)

  useEffect(() => dialogTumbler(isDialogVisible), [isDialogVisible])

  const defaultActions = [
    <Button
      key="confirm"
      variant="contained"
      color="primary"
      disabled={confirmDisabled}
      onClick={onConfirm}
      label={confirmLabel}
    />,
    <Button
      color="secondary"
      key="cancel"
      variant="outlined"
      onClick={onCancel}
      label={cancelLabel}
    />,
  ]

  return (
    <StyledPopper
      open={isVisible}
      id={id}
      anchorEl={anchorRef}
      placement={placement}
      disablePortal={true}
      modifiers={{ flip: { enabled: false } }}>
      <StyledPaper elevation={2}>
        <StyledDialogTitle>{dialogTitle}</StyledDialogTitle>
        <StyledDialogContent>
          <StyledDialogContentText>{contentText || null}</StyledDialogContentText>
        </StyledDialogContent>
        <StyledDialogActions>{actionsButtons || defaultActions}</StyledDialogActions>
      </StyledPaper>
    </StyledPopper>
  )
}

Popper.propTypes = {
  actionsButtons: T.oneOfType([T.instanceOf(Element), T.array]),
  anchorRef: T.oneOfType([T.instanceOf(Element), T.object, T.func]),
  cancelLabel: T.string,
  confirmDisabled: T.bool,
  confirmLabel: T.string,
  contentText: T.string,
  dialogTitle: T.string,
  id: T.string,
  isDialogVisible: T.bool,
  onCancel: T.func,
  onConfirm: T.func,
}
